import { If } from "react-conditional-components-renderer";
import AscAvatar from "../AscAvatar/AscAvatar";
import AscDropdown from "../AscDropdown/AscDropdown";
import classNames from "classnames";
import styles from "./AscAdminProfileDropdown.module.scss";

export interface AscAdminProfileDropdownProps {
  avatarUrl?: any;
  name?: string;
  schoolName?: string;
  children?: JSX.Element[];
  className?: string;
}

export default function AscAdminProfileDropdown({
  avatarUrl,
  name,
  schoolName,
  children,
  className,
}: AscAdminProfileDropdownProps) {
  const options = children?.concat();

  return (
    <AscDropdown
      title={
        <div className={styles.nameAndAvatarContainer}>
          {avatarUrl}
          <If test={!avatarUrl}>
            <AscAvatar src={avatarUrl} />
          </If>

          <div className={styles.nameContainer}>
            <span className={styles.name}>{name}</span>
            <span className={styles.subtitle}>{schoolName}</span>
          </div>
        </div>
      }
      optionItemClassName={styles.optionItem}
      optionContainerClassName={styles.optionContainer}
      variant="secondary"
      className={classNames(className)}
      alignment="right"
    >
      {options}
    </AscDropdown>
  );
}
